export * from './index';



// WEBPACK FOOTER //
// ./~/angular-font-awesome/angular-font-awesome.ts